import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild, effect, input, output, signal } from '@angular/core';
import { DEFAULT_VIDEO_COLUMNS, VIDEO_COLUMN_DEFS, VideoColumnDef, VideoColumnKey } from '../videos/videos';

@Component({
  selector: 'ttor-video-metrics',
  imports: [],
  templateUrl: './video-metrics.html',
  styleUrl: './video-metrics.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TtoVideoMetricsComponent {
  @ViewChild('ttoColumnSelectDialog', { static: false }) filterDrawerDialog?: ElementRef<HTMLDialogElement>;

  visibleColumns = input.required<Set<VideoColumnKey>>();
  columnsChange = output<Set<VideoColumnKey>>();

  pendingColumns = signal<Set<VideoColumnKey>>(new Set(DEFAULT_VIDEO_COLUMNS));
  selectedTab = signal<'engagement' | 'content-performance' | 'ads-performance' | 'audience'>('engagement');

  readonly engagementCols: VideoColumnDef[] = VIDEO_COLUMN_DEFS.filter(c => c.tab === 'engagement');
  readonly contentPerformanceCols: VideoColumnDef[] = VIDEO_COLUMN_DEFS.filter(c => c.tab === 'content-performance');
  readonly adsPerformanceCols: VideoColumnDef[] = VIDEO_COLUMN_DEFS.filter(c => c.tab === 'ads-performance');
  readonly audienceCols: VideoColumnDef[] = VIDEO_COLUMN_DEFS.filter(c => c.tab === 'audience');

  constructor() {
    effect(() => {
      this.pendingColumns.set(new Set(this.visibleColumns()));
    });
  }

  setTab(tab: 'engagement' | 'content-performance' | 'ads-performance' | 'audience'): void {
    this.selectedTab.set(tab);
  }

  getTabClass(tab: 'engagement' | 'content-performance' | 'ads-performance' | 'audience'): string {
    if (this.selectedTab() === tab) {
      return 'border-[--primary] text-[--primary]';
    }
    return 'border-transparent text-secondary hover:border-[--border] hover:text-primary';
  }

  getSelectedTabIconClass(tab: 'engagement' | 'content-performance' | 'ads-performance' | 'audience'): string {
    if (this.selectedTab() === tab) {
      return 'text-[--primary]';
    }
    return 'text-secondary group-hover:text-primary';
  }

  isChecked(key: VideoColumnKey): boolean {
    return this.pendingColumns().has(key);
  }

  toggleColumn(key: VideoColumnKey): void {
    this.pendingColumns.update(cols => {
      const next = new Set(cols);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }

  apply(): void {
    this.columnsChange.emit(new Set(this.pendingColumns()));
    this.closeDrawer();
  }

  clear(): void {
    this.pendingColumns.set(new Set(DEFAULT_VIDEO_COLUMNS));
  }

  closeDrawer(): void {
    this.filterDrawerDialog?.nativeElement?.close();
  }
}
